import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import jwt_decode from 'jwt-decode';
import axios from 'axios';
import logo from '../../../../assets/images/logo.png';
import { NuInput, NuInputLogin, NuInputToggle } from '../../../../Components/Utils/Input';
import { useToast } from '../../../../Components/Others/ToastServices';
import CryptoJS from "crypto-js";
import ChangePassword from './changePassword';
import '../../../../App.css';
import { GetDashboardRole } from '../../../../Components/Utils/roles';



axios.defaults.baseURL = window.WEB_APP_API_URL;
function AnotherLogin() {
  const toast = useToast()
  const [showForgetPassword, setShowForgetPassword] = useState(false);
  const [isLoading,setIsLoading] = useState(false);
  const handleForgetPasswordClick = () => {
    setShowForgetPassword(true);
  };
  const handleCloseModal = () => {
    setShowForgetPassword(false)
  };
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });


  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (localStorage.getItem("nEkOtReSuEdArT") && localStorage.getItem("sLiAtEdReSuEdArT") && localStorage.getItem("sSeCcArEsUeDaRt") ) {
      window.location.replace(GetDashboardRole("")?"/dashboard":GetDashboardRole("sales")?"/dashboard/sales":GetDashboardRole("procurement")?"/dashboard/procurement":GetDashboardRole("store")?"/dashboard/stores":"#");
    }
  }, []);


  const encryptData = async (data,location) =>{
    let Test = JSON.stringify(data)
    const Value = CryptoJS.AES.encrypt(Test,process.env.REACT_APP_ACCESS_KEY).toString();
    localStorage.setItem(location,Value);
    // console.log('EnC',Value)
  }

  const [createNew, setCreateNew] = useState({
    email: '',
    password: '',
  });
  const formik = useFormik({
    initialValues: createNew,
    validateOnChange: false,
    validationSchema: yup.object({
      email: yup.string().required('Email is Required'),
      password: yup.string().required('Password is Required'),
    }),
    onSubmit: async (value) => {
      setIsLoading(true);
      await axios
        .post('/auth/login', value)
        .then( async(res) => {
          if (res.data.status) {
            setIsLoading(false);
            let userToken = res?.data?.token;
            await encryptData(userToken,'nEkOtReSuEdArT');
            let decodeToken = jwt_decode(res?.data?.token);
            await encryptData(decodeToken,'sLiAtEdReSuEdArT');
            let permissions = res?.data?.permissions
            await encryptData(permissions,'sSeCcArEsUeDaRt');
              toast.open(
              {
                message:"Login successfully",
                description: res.data.msg || 'Successfully logged in  ',
                type:"success",
              }
            )
            window.location.replace(GetDashboardRole("")?"/dashboard":GetDashboardRole("sales")?"/dashboard/sales":GetDashboardRole("procurement")?"/dashboard/procurement":GetDashboardRole("store")?"/dashboard/stores":"/dashboard");
          } else {
            setIsLoading(false);
            toast.open(
              {
                message:"Login unsuccessfully",
                description: res.data.msg || 'Login failed ',
                type:"error",
              }
            )
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.open(
            {
              message:"Login unsuccessfully",
              description: err?.response.data.msg || 'Login failed or network error  ',
              type:"error",
            }
          )
        });
    },

    
  });

  return (
    <div className='w-full h-[100vh] login-image '>
    <div className="text-outside hidden md:block">
    <h1 className="text-lg font-bold mb-4">nuservice</h1>
    <div className="space-y-1 text-top mb-6 ">
      <p className="text-3xl font-extrabold ">Simplify </p>
      <p className="text-3xl font-extrabold "> Inspections.</p>

      <p className="text-3xl font-extrabold ">Elevate</p>
      <p className="text-3xl font-extrabold ">Performance.</p>
      <p className="text-sm mt-2">Built for quality-driven teams.</p>

    </div>
    </div>

  <div className="w-full h-[calc(100vh-30px)] flex items-center justify-end">
  <div className="min:w-[60%] min:h-[70vh] py-4 px-8 
  mr-4 sm:mr-6 md:mr-10 lg:mr-20 xl:mr-28 
  rounded-2xl bg-white backdrop-blur-sm 
  flex justify-center items-center border border-solid border-white">
     <div className="w-full px-3 flex flex-col ">
        <div className="w-[65%] rounded-[1.5rem] content-center h-[65%] flex items-center justify-center gap-2 drop-shadow-lg mx-auto mb-2">
          <img className="w-16" src={logo} alt="logo" />
        </div>
        <p className="text-[#6B43C6] font-extrabold text-[24px] text-center">Login</p>
                   <form onSubmit={formik.handleSubmit} className=''>
                <div className=' justify-center '>
                  <NuInputLogin 
                    type="text"
                    label='Email *'
                    placeholder='Enter Your Mail'
                    formik={formik}
                    name='email'
                    width='w-full'
                    padding='py-2'
                   
                  />

                  <NuInputToggle
                    label='Password *'
                    placeholder='************'
                    formik={formik}
                    name='password'
                    width='w-full'
                    padding='py-2'
                   
                    
                  />
                </div>

                   <div className='  text-center'>
                <span onClick={handleForgetPasswordClick} className=' px-5 font-sans  not-italic text-sm medium text-right cursor-pointer'>Forgot Your Password? Pls <span className='text-[#6B43C6]'>reset </span></span>
                </div>
                
                <div className="flex justify-center mt-6">
  <button
    type="submit"
    className={`${
      isLoading ? "cursor-wait bg-[#d0f6f3]" : "cursor-pointer bg-[#6B43C6]"
    } border-none text-white text-xs h-10 rounded-3xl w-[58%]`}
  >
    Login
  </button>
</div>

              </form>
            </div>
          </div>
       
      </div>
      <p className="text-white text-center text-xs italic  font-extralight absolute bottom-2 w-full">
    {/* © */}
    product by numota
  </p>    {showForgetPassword && <ChangePassword onClose={handleCloseModal} />}
    </div>
  );
}
export default AnotherLogin;